import { Component, Output, EventEmitter } from "@angular/core";

@Component({
    selector: 'app-money-manager',
    templateUrl: './money-manager.component.html',
    styleUrls: ['./money-manager.component.scss'],
    standalone: false
})
export class MoneyManagerComponent {
    @Output() onClickMoneyManager: EventEmitter<null> = new EventEmitter();

    constructor() {}
}
